import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { CSSProperties, FC } from 'react';

import { HIGHLIGHTED_TEXT_ATTRIBUTE_NAME } from 'APP/constants/messages';

import { useTextHighlighterPresenter } from './TextHighlight.presenter';
import styles from './TextHighlighter.styles.m.css';
import { ITextHighlighterProps } from './TextHighlighter.types';
import { TEXT_HIGHLIGHT_BORDER_RADIUS } from './TextHighlighter.utils';
import { TextHighlighterRange } from './TextHighlighterRange/TextHighlighterRange';

export const TextHighlighter: FC<ITextHighlighterProps> = observer((props) => {
  const { className, highlightClassName, highlightRef, ...presenterProps } = props;
  const presenter = useTextHighlighterPresenter(presenterProps);

  if (!props.highlightedText) {
    return null;
  }

  const containerStyle = {
    '--text-highlight-border-radius': `${TEXT_HIGHLIGHT_BORDER_RADIUS}px`,
  } as CSSProperties;

  return (
    <span
      className={classNames(styles.container, className)}
      style={containerStyle}
    >
      <span
        {...{ [HIGHLIGHTED_TEXT_ATTRIBUTE_NAME]: !!presenter.highlightLayout?.length }}
        ref={highlightRef}
        className={classNames(styles.wrapper, highlightClassName)}
        style={{ top: `${presenter.relativeTop}px` }}
      >
        {presenter.highlightLayout?.map((rangeParams) => (
          <TextHighlighterRange
            key={rangeParams.id}
            {...rangeParams}
          />
        ))}
      </span>
    </span>
  );
});
